import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDV-XWm5YEA1XWVUdBELQu3lpxNn5j2BV8",
    authDomain: "essential-haiku-254805.firebaseapp.com",
    databaseURL: "https://essential-haiku-254805.firebaseio.com",
    projectId: "essential-haiku-254805",
    storageBucket: "essential-haiku-254805.firebasestorage.app",
    messagingSenderId: "824596323368",
    appId: "1:824596323368:web:6be9d93fa24156b872291d",
    measurementId: "G-0PENKEXXWX"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app, "payment");

export default db;
